/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {triggerCampaign} from '../api'

export const useMutationTriggerCampaign = createReactQueryMutationHook('triggerCampaign', triggerCampaign)
